import styled from 'styled-components';

const Card = styled.div`
  box-sizing: border-box;
  max-width: 410px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Form = styled.div`
  width: 300px;
  padding: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
  border-radius: 0px;
  box-shadow: 5px 5px black;
  background: linear-gradient(135deg, rgba(32,42,59,0.97) 100%, rgba(2,206,247,0.2413340336134454) 100%);
`;

const Input = styled.input`
  border:0;
  background: black;
  display: block;
  margin: 20px auto;
  text-align: center;
  border: 1px solid #3498db;
  padding: 14px 10px;
  width: 200px;
  outline: none;
  color: white;
  border-radius: 0px;
  transition: 0.25s;
`;

const Button = styled.button`
  border:0;
  background: black;
  display: block;
  margin: 20px auto;
  text-align: center;
  border: 1px solid #2ecc71;
  padding: 14px 40px;
  outline: none;
  color: white;
  border-radius: 0px;
  transition: 0.25s;
  cursor: pointer;
`;

const Logo = styled.img`
  width: 50%;
  margin-bottom: 1rem;
`;

const Error = styled.div`
  background-color: red;
  color: white;
`;

export { Form, Input, Button, Logo, Card, Error };